export default "__VITE_ASSET__BdKPbMYF__"